import { __decorate } from "tslib";
import { Mixins, Component, Prop } from 'vue-property-decorator';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import ButtonLoaderMixin from '@/helpers/vue_mixins/ButtonLoaderMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import GracePeriodActivationMutation from '@/plugins/graphql/mutations/v2/billing/grace-period-activation.gql';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import AppBasic from '@/plugins/graphql/queries/v2/app-basic.gql';
import { Mutation } from 'vuex-class';
let GracePeriodActivation = class GracePeriodActivation extends Mixins(AlertMixin, ButtonLoaderMixin, ViewportSizeMixin, RouterParamsAppMixin) {
    /**
     * Set Tooltip Max Width for different pages
     * @author Peter John Alvarado <peterjohn@gorated.ph>
     * @since Version {0.15.0}
     *
     * @return {String}
     */
    get maxWidth() {
        if (this.deactivationPage) {
            return 'unset';
        }
        return '199';
    }
    /**
     * Set Tooltip Left Offset Width for different pages
     * @author Peter John Alvarado <peterjohn@gorated.ph>
     * @since Version {0.15.0}
     *
     * @return {String}
     */
    get offsetLeft() {
        if (this.deactivationPage) {
            return '100';
        }
        return '0';
    }
    async onActivate() {
        this.requestOnFlight();
        await this.activate()
            .then(() => {
            this.successNotification('Success');
        })
            .catch((e) => {
            this.errorNotification(e.message);
        })
            .finally(() => {
            this.requestDone();
            this.$emit('activation:done');
            /**
             * Trigger Mutation for Hiding Deactivation Dialog
             * Unfortunately `emitter` doesn't work since this component is already
             * destroyed upon sending mutation
             * @author Peter John Alvarado <peterjohn@gorated.ph>
             * @since Version {0.15.0}
             */
            if (this.deactivationPage) {
                this.hideDeactivationReminderDialog(true);
            }
        });
    }
    activate() {
        return this.$apollo.mutate({
            mutation: GracePeriodActivationMutation,
            variables: {
                input: { billingUuid: this.uuid },
            },
            refetchQueries: [
                {
                    query: AppBasic,
                    variables: {
                        appUuid: this.appUUID,
                    },
                },
            ],
        });
    }
};
__decorate([
    Mutation('hideDeactivationReminderDialog')
], GracePeriodActivation.prototype, "hideDeactivationReminderDialog", void 0);
__decorate([
    Prop({ type: String, required: true })
], GracePeriodActivation.prototype, "uuid", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], GracePeriodActivation.prototype, "deactivationPage", void 0);
GracePeriodActivation = __decorate([
    Component
], GracePeriodActivation);
export default GracePeriodActivation;
